import React, { useContext, useEffect, useState } from "react";
import { useMemo } from "react";
import styles from "./styles/Assets.module.css";
import { Beneficiarytrustee } from "../User/Beneficiarytrustee/Beneficiarytrustee";
import { selectLogo } from "../User/Assets/selectLogo";
import { AssetTable } from "./AssetTable";
import AssetInfo from "./AssetInfo";
import AssetsFilter from "./AssetsFilter";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { getAssetTypeTranslated } from "../../Utils/translationUtils";
import useWindowDimensions from "../Footer/footer";

function Assets({ data, trustees }) {
  const [info, setInfo] = useState(false);
  const { width } = useWindowDimensions();
  const assetNameMaxLength = 25;
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.Beneficiary.Assets
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setContent(websiteCurrentLang.content.Beneficiary.Assets);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const columns = useMemo(
    () => [
      {
        Header: dublicatedcontent.dublicatedText63,
        accessor: "asset_name",
        Cell: ({ row, value }) => {
          const asset_type = row.original["asset_type"];
          const logo = selectLogo(asset_type);
          return (
            <div className={styles.asset_name}>
              <div
                className={styles.asset_logo}
                style={{ backgroundImage: `url(${logo})` }}
              ></div>
              <div>
                {value.length > assetNameMaxLength ? (
                  <>{value.slice(0, assetNameMaxLength) + "..."}</>
                ) : (
                  <>{value}</>
                )}
                <div className={styles.beneficiary_list_mobile}>
                  {getAssetTypeTranslated(
                    asset_type,
                    undefined,
                    dublicatedcontent
                  )}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: dublicatedcontent.dublicatedText58,
        accessor: "asset_type",
        Cell: ({ row, value }) => {
          return (
            <span className={styles.beneficiary_list}>
              {getAssetTypeTranslated(value, undefined, dublicatedcontent)}
            </span>
          );
        },
      },
      {
        Header: dublicatedcontent.dublicatedText64,
        accessor: "trustees",
        disableSortBy: true,
        Cell: ({ row, value }) => {
          let trustees_ = [];

          if (Array.isArray(value)) {
            value?.map((trustee_id) => {
              let name = "";
              let profile_avatar = null;
              trustees.map((e) => {
                if (e.user_id === trustee_id) {
                  name = e?.name + ("last_name" in e ? " " + e?.last_name : "");
                  profile_avatar = e.profile_avatar;
                }
                return null;
              });
              trustees_.push(
                <Beneficiarytrustee
                  key={name}
                  name={name}
                  priority={1}
                  deleatable={false}
                  textFontSize={"16px"}
                  avatar={profile_avatar}
                />
              );
              return null;
            });
          } else {
            console.log("THIS IS NOT AN ARRAY");
          }
          return (
            <div
              className={styles.beneficiary_list}
              key={Math.random().toString()}
            >
              {trustees_.length === 0 ? (
                <>&nbsp;</>
              ) : trustees_.length > 5 ? (
                trustees_.splice(0, width > 767 ? 5 : 3)
              ) : (
                trustees_
              )}
            </div>
          );
        },
      },
      {
        Header: content.assetsHeader4,
        id: "expander",
        Cell: ({ row }) => {
          return (
            <div
              onClick={() => {
                // setToEdit(row.original);setOpenEdit(true)
                return;
              }}
              className={styles.action_button}
            ></div>
          );
        },
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
    ],
    [data]
  );
  const [filter, setFilter] = useState();

  return (
    <div className={styles.main_box}>
      <div className={styles.table_div}>
        <AssetsFilter
          placeholder={dublicatedcontent?.dublicatedText65}
          setFilter={setFilter}
        ></AssetsFilter>
        <AssetTable
          click={(data) => setInfo(data)}
          columns={columns.slice(0, 5)}
          data={data}
          filter={filter}
          setFilter={null}
          assetsLength={data}
        />
      </div>
      {info && (
        <AssetInfo
          onClose={() => setInfo(null)}
          asset={info}
          trustees={trustees}
          allAssets={data}
        />
      )}
    </div>
  );
}

export default Assets;
